<template>
  <el-dialog :visible="show" :title="title" append-to-body @close="$emit('update:show', false)" width="750px" :close-on-click-modal="false">
    <div class="v-row">
      <category-list :lists.sync="category" :type="type" :category_id.sync="media_category_id" @success="getList(1)"></category-list>

      <div class="preview-lists-box" v-loading="loadingLists">
        <!-- 资源列表-header -->
        <div class="preview-lists-header">
          <div class="left v-row v-row-align-center">
            <template v-if="media_category_id != -2">
              <el-checkbox v-if="mode == 2" v-model="checkAll" @change="changeCheckAll"><span class="v-font-12">全选</span></el-checkbox>
              <el-button size="min" class="v-ml-10" type="primary" @click="chooseFile" :loading="loadingUpload">手动上传</el-button>
              <el-button size="min" class="v-ml-10" @click="batchDeleteMedia" :disabled="lists.filter((item) => item.active).length == 0">删除</el-button>
              <el-button size="min" class="v-ml-10" @click="showMoveCategory" :disabled="lists.filter((item) => item.active).length == 0">移动</el-button>
              <el-button size="min" class="v-ml-10" @click="changeMode">{{ mode == 1 ? '编辑' : '完成' }}</el-button>
            </template>
          </div>
          <div class="right v-row v-row-align-center">
            <el-input size="small" v-model="keyword" placeholder="请输入文件名称"></el-input>
            <el-button size="mini" type="primary" class="v-ml-5" @click="getList(1)">搜索</el-button>
          </div>
        </div>

        <!-- 资源列表 -->
        <div v-if="lists.length" class="preview-lists">
          <div v-for="(item, index) in lists" :key="item.id" class="preview-item" :class="{ active: item.active, audio: type == 'audio' }">
            <div class="preview-box">
              <img v-if="type == 'image'" @click="toggleActive(item)" class="preview" :src="item.preview | thumbImage(166, 166)" />
              <img v-if="type == 'video'" @click="toggleActive(item)" class="preview" :src="item.preview | thumbVideo(166, 166)" />
              <audio v-if="type == 'audio'" class="audio-player" :ref="'audio-' + index" controls :src="item.preview" @play="handlePlay(index)" @pause="handlePause(index)"></audio>
              <i v-if="item.active" class="iconfont icon-right right"></i>
            </div>

            <!-- 标题、分类、查看、修改、删除 -->
            <div class="preview-footer">
              <el-checkbox v-model="item.active" @change="resetChecked(item)"></el-checkbox>
              <div class="name v-ml-5" @click="toggleActive(item)">
                <div v-if="media_category_id == -1" class="category">
                  {{ item.media_category_name ? '[' + item.media_category_name + ']' : '[未分组]' }}
                </div>
                <div class="txt v-ellipsis">{{ item.name }}</div>
              </div>
              <div class="operate">
                <a class="operate-btn" :href="item.preview" target="_blank"><i class="el-icon-zoom-in"></i></a>
                <i @click="editName(item)" class="operate-btn el-icon-edit v-mr-10 v-ml-10"></i>
                <el-popconfirm title="确认删除?" @onConfirm="deleteMedia(item)">
                  <i slot="reference" class="operate-btn el-icon-delete"></i>
                </el-popconfirm>
              </div>
            </div>
          </div>
        </div>

        <el-pagination
          v-if="lists.length > 0"
          layout="total,sizes,prev, pager, next"
          @size-change="
            (page_size) => {
              getList(page, page_size);
            }
          "
          @current-change="
            (page) => {
              getList(page);
            }
          "
          :current-page.sync="page"
          :total="total"
        ></el-pagination>

        <div class="placeholder v-row v-row-center" v-if="lists.length == 0" v-loading="loadingUpload">
          <div>暂无资源数据</div>
          <el-button v-if="media_category_id != -2" type="text" @click="chooseFile">手动上传</el-button>
        </div>
      </div>

      <category-move v-if="isShowCategoryList" :show.sync="isShowCategoryList" :category="category" :rows="rows" @success="getList(1)"></category-move>

      <input ref="fileInput" hidden class="file" type="file" :multiple="multiple" :accept="type + '/*'" />
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" size="small" :disabled="mode == 2">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import categoryList from './category-list';
import categoryMove from './category-move';

export default {
  props: ['show', 'type', 'multiple'], //type :image video audio 1图片  2视频 3音频

  components: { categoryList, categoryMove },

  data() {
    return {
      title: '',
      loading: false,
      image: null,
      category: [],
      media_category_id: -1,
      lists: [],
      page: 1,
      page_size: 10,
      total: 0,
      keyword: '',
      loadingLists: false,
      loadingUpload: false,
      loadingMoving: false,
      isShowCategoryList: false,
      rows: null,
      checkAll: false, //全选
      mode: 1, //1正常 2编辑
      audioPlayingIndex: -1,
    };
  },

  mounted() {
    this.infoDialogTitle();
    this.getList();
  },

  methods: {
    //设置弹窗标题
    infoDialogTitle() {
      if (this.type == 'image') {
        this.title = `${this.multiple ? '批量' : ''}选择图片`;
      }
      if (this.type == 'video') {
        this.title = `${this.multiple ? '批量' : ''}选择视频`;
      }
      if (this.type == 'audio') {
        this.title = `${this.multiple ? '批量' : ''}选择音频`;
      }
    },

    //资源列表
    async getList(page, page_size) {
      this.loadingLists = true;
      this.page = page ? page : this.page;
      this.page_size = page_size ? page_size : this.page_size;
      try {
        let res = await this.api.media.lists({
          page: this.page,
          page_size: this.page_size,
          type: this.type == 'image' ? (this.media_category_id == -2 ? [1, 4] : 1) : this.type == 'video' ? 2 : 3,
          keyword: this.keyword,
          media_category_id: this.media_category_id,
          space: this.media_category_id == -2 ? 'system' : 'user',
        });
        this.lists = res.data.data;
        this.total = res.data.total;
      } catch (e) {
        console.error(e);
      }
      this.loadingLists = false;
    },

    //单条删除
    deleteMedia(row) {
      this.doDeleteMedia([row.id]);
    },

    //批量删除文件
    async batchDeleteMedia() {
      try {
        let ids = this.lists.filter((item) => item.active).map((item) => item.id);
        await this.$confirm('确认删除选中项?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        this.doDeleteMedia(ids);
      } catch (e) {
        console.error(e);
      }
    },

    //删除多媒体文件
    async doDeleteMedia(ids) {
      try {
        await this.api.media.deleteMedia({ ids });
        this.$message.success('删除成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
    },

    //切换勾选
    toggleActive(row) {
      this.$set(row, 'active', !row.active);
      this.resetChecked(row);
    },

    //重置勾选项
    resetChecked(row) {
      if (!this.multiple && row.active && this.mode == 1) {
        //非批量 &&  非选中 && 非编辑模式
        this.lists.forEach((item) => {
          if (item.id != row.id) {
            this.$set(item, 'active', false);
          }
        });
      }
    },

    //移动分类
    async showMoveCategory() {
      this.rows = this.lists.filter((item) => item.active);
      this.isShowCategoryList = true;
    },

    //选择上传文件
    chooseFile() {
      let fileInput = this.$refs.fileInput;
      fileInput.click();
      fileInput.onchange = (e) => {
        let files = e.target.files;
        this.doUpload(files);
      };
    },

    //上传文件
    async doUpload(files) {
      this.loadingUpload = true;
      try {
        let res = await this.utils.upload.uploadFiles(files, {
          bucket: 'vybbasevr',
        });
        this.$refs.fileInput.value = '';
        this.addToMedia(res);
      } catch (e) {
        console.error(e);
      }
      this.loadingUpload = false;
    },

    //加入媒体库
    async addToMedia(media_data) {
      try {
        await this.api.media.addMedia({
          type: this.type == 'image' ? 1 : this.type == 'video' ? 2 : 3,
          space: 'user',
          media_data,
          media_category_id: this.media_category_id,
        });
        this.keyword = '';
        this.getList(1);
      } catch (e) {
        console.error(e);
      }
    },

    //全选
    changeCheckAll() {
      this.lists.forEach((item) => {
        this.$set(item, 'active', this.checkAll);
      });
    },

    //切换编辑模式
    changeMode() {
      this.mode = this.mode == 1 ? 2 : 1;
      this.checkAll = false;
      this.lists.forEach((item) => {
        this.$set(item, 'active', false);
      });
    },

    //修改资源名称
    async editName(row) {
      try {
        let res = await this.$prompt('修改资源名称', '资源修改', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '1-10个字符',
          inputValue: row.name,
          inputPattern: /^[\S]{1,10}$/,
          inputErrorMessage: '长度不正确',
          closeOnClickModal: false,
        });
        this.loading = true;
        await this.api.media.updateMedia({
          field_data: { name: res.value },
          ids: [row.id],
        });
        this.$message.success('修改成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
    },

    //监听播放音乐
    handlePlay(index) {
      let playing = this.$refs['audio-' + this.audioPlayingIndex];
      if (playing && playing[0]) {
        playing[0].pause();
      }
      this.audioPlayingIndex = index;
    },

    handlePause(index) {
      if (index == this.audioPlayingIndex) {
        this.audioPlayingIndex = -1;
      }
    },

    //确认选择
    doSubmit() {
      let selected = this.lists.filter((item) => item.active);
      if (selected.length == 0) {
        this.$message.error('请先选择图片');
        return;
      }
      this.$emit('change', selected);
      this.$emit('update:show', false);
    },
  },
};
</script>

<style scoped lang="scss">
.preview-lists-box {
  min-height: 100px;
  padding: 0 10px;
  flex: 1;
}

.preview-lists-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
}

.preview-lists {
  display: flex;
  flex-wrap: wrap;
  height: 350px;
  overflow-y: auto;
  align-items: flex-start;
  align-content: flex-start;
}

.preview-item {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  display: inline-block;
  width: 166px;

  &.audio {
    width: 250px;
  }

  &.audio .preview-box {
    width: 240px;
    height: 60px;
    padding: 0 5px;
  }

  &.audio .audio-player {
    height: 40px;
  }

  &.active {
    background: #eee;
  }

  &.active:before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    border-left: 40px solid transparent;
    border-top: 40px solid #409eff;
    z-index: 3;
  }

  &.active .right {
    color: #fff;
    position: absolute;
    right: 4px;
    top: 4px;
    z-index: 4;
    font-size: 12px;
  }

  .preview-box {
    width: 100%;
    height: 166px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ddd;
    position: relative;
    overflow: hidden;
    background: #eee;
  }

  .preview {
    display: block;
    cursor: pointer;
    max-width: 100%;
    max-height: 100%;
  }
}

.preview-footer {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 5px;

  .name {
    flex: 1;
    display: flex;
    align-items: center;
    padding-right: 10px;
    min-width: 0;
  }

  .category {
    margin-right: 3px;
    flex-shrink: 0;
    font-size: 12px;
    color: #409eff;
  }

  .txt {
    flex: 1;
    min-width: 0;
  }

  .operate {
    display: flex;
    align-items: center;
  }

  .operate-btn {
    color: #666;
  }
}

.placeholder {
  text-align: center;
  line-height: 100px;
}
</style>
